export const DEFAULT_PAYMENT_AMOUNT = 20
export const COST_PER_PERSON = 5

export const PAYMENT_PRESET_FLAG = false
